import * as React from 'react';
import { GroundingEnum } from "../../schemas/branches";
import { compareById } from "../utils";

import { useMuiNodeColDefs } from "./colDefs";
import { observer } from "mobx-react-lite";
import { GridColDef, GridRowsProp, } from "@mui/x-data-grid";

import { useApiCall } from "../../../../hooks/useApiCall";
import { useParams } from "react-router-dom";
import { createProjectNode, deleteProjectNode, getProjectNodes, updateProjectNode } from "../../api/nodes";
import { NodeInterface } from "../../schemas/nodes";

import BaseTable, { getHandlerDeleteClick, getHandlerDuplicateClick, TablePropsInterface } from "../BaseTable";
import i18nStore from "../../../../i18n/store";
import { v4 as uuidv4 } from "uuid";


const NodeTable = observer((props: TablePropsInterface) => {
    const translations = i18nStore.getTranslations;
    const params = useParams();
    const projectId: number = +(params.projectId || 0);

    const [rows, setRows] = React.useState<GridRowsProp>([]);

    const handlerDuplicateClick: any = getHandlerDuplicateClick(
        projectId,
        rows,
        setRows,
        createProjectNode,
    );

    const handlerDeleteClick: any = getHandlerDeleteClick(
        projectId,
        rows,
        setRows,
        deleteProjectNode,
    );

    const colDefs: GridColDef[] = useMuiNodeColDefs(rows, setRows, handlerDeleteClick, handlerDuplicateClick, updateProjectNode);

    const getNodesApi = useApiCall<NodeInterface[]>(
        () => getProjectNodes(projectId).then(nodes => {
            setRows(nodes.sort(compareById).reverse());
            return nodes;
        }),
        [],
    );

    return (
        <BaseTable
            colDefs={colDefs}
            rows={rows}
            setRows={setRows}
            getTableApi={getNodesApi}
            tableName={props.tableName}
            tableTitle={translations.nodes}
            createApiFunc={createProjectNode}
            updateApiFunc={updateProjectNode}
            createEmptyRow={() => {
                return {
                    id: uuidv4(),
                    name: '',
                    u_nom: null,
                    p_load: null,
                    q_load: null,
                    grounding: GroundingEnum.NOT_GROUNDED,
                    is_active: true,
                };
            }}
        />
    );
});

export default NodeTable;
